var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 6H5.25C5.44891 6 5.63968 5.92098 5.78033 5.78033C5.92098 5.63968 6 5.44891 6 5.25V0.75C6 0.551088 5.92098 0.360322 5.78033 0.21967C5.63968 0.0790176 5.44891 0 5.25 0H0.75C0.551088 0 0.360322 0.0790176 0.21967 0.21967C0.0790176 0.360322 0 0.551088 0 0.75V5.25C0 5.44891 0.0790176 5.63968 0.21967 5.78033C0.360322 5.92098 0.551088 6 0.75 6ZM8.25 6H12.75C12.9489 6 13.1397 5.92098 13.2803 5.78033C13.421 5.63968 13.5 5.44891 13.5 5.25V0.75C13.5 0.551088 13.421 0.360322 13.2803 0.21967C13.1397 0.0790176 12.9489 0 12.75 0H8.25C8.05109 0 7.86032 0.0790176 7.71967 0.21967C7.57902 0.360322 7.5 0.551088 7.5 0.75V5.25C7.5 5.44891 7.57902 5.63968 7.71967 5.78033C7.86032 5.92098 8.05109 6 8.25 6ZM0.75 13.5H5.25C5.44891 13.5 5.63968 13.421 5.78033 13.2803C5.92098 13.1397 6 12.9489 6 12.75V8.25C6 8.05109 5.92098 7.86032 5.78033 7.71967C5.63968 7.57902 5.44891 7.5 5.25 7.5H0.75C0.551088 7.5 0.360322 7.57902 0.21967 7.71967C0.0790176 7.86032 0 8.05109 0 8.25V12.75C0 12.9489 0.0790176 13.1397 0.21967 13.2803C0.360322 13.421 0.551088 13.5 0.75 13.5ZM10.5 13.5C12.1545 13.5 13.5 12.1545 13.5 10.5C13.5 8.8455 12.1545 7.5 10.5 7.5C8.8455 7.5 7.5 8.8455 7.5 10.5C7.5 12.1545 8.8455 13.5 10.5 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/Category.3c12716a0d05dd6fe72f5ffdc963f428.svg";
export { ForwardRef as ReactComponent };